import React from 'react'
import Sidebar from "../components/Sidebar"
import UserTable from '../components/UsersTable';
import { useState, useEffect } from "react";
import { Button, Spinner, Modal } from "react-bootstrap"
import "../css/mnguser.css"

import * as MdIcons from "react-icons/md";

export default function MngUsers() {

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false)
    }, 1300);
  }, [])

  return (
    <>
      {
        loading ?

          <div className="loader-screen">
            <Spinner className="loader-icon" animation="border" variant="primary" />
          </div>

          :

          <div className="home">
            <Sidebar />
            <div className="homeContainer">
              <div className="listContainer">
                
                <UserTable />

              </div>
            </div>
          </div>
      }
    </>
  )
}
